<template>
    <div class="solution-main">
        <!-- 头部 -->
      <headers></headers>
        <section class="ban ban3">
            <div class="col">
                <div>
                    <h1 class="title1">展装解决方案</h1>
                    <p>为展装企业提供全面高效、标准管理、资源共享的数字化升级解决方案。</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col box-3" style="padding-top: 50px;">
                <h4 class="title3" style="margin-bottom: 30px;">核心优势</h4>
                <div class="list-hxys">
                    <dl>
                        <dt>开放云生态</dt>
                        <dd>丰富商业机遇<br>
                            前沿会展资讯<br>
                            满足综合需求<br>
                            高效流程设计</dd>
                    </dl>
                    <dl>
                        <dt>安全高效</dt>
                        <dd>严格的权限划分<br>
                            智能的内部协同<br>
                            直观的数据呈现<br>
                            安全的云端储存</dd>
                    </dl>
                    <dl>
                        <dt>专业服务</dt>
                        <dd>先进的运营理念<br>
                            专业的运营经验<br>
                            专业的研发团队<br>
                            一对一服务护航</dd>
                    </dl>
                </div>
            </section>
            <section class="col box-3" style="">
                <h4 class="title3" style="margin-bottom: 70px;">应用场景</h4>
                <div class="box-yycj">
                    <ul class="ul1" id="list-btn">
                        <li class="active">内部协同</li>
                        <li>业务拓展</li>
                        <li>展示推广</li>
                    </ul>
                    <div class="div1">
                        <p class="p1" id="_title" style="border-bottom: none;">展装云+设计云</p>
                        <ul class="ul2" id="_list">
                            <li>·项⽬沟通与协作</li>
                            <li>·客户记录跟踪</li>
                            <li>·设计模型下载</li>
                        </ul>
                    </div>
                    <div class="div2">
                        <div class="img-box"><img id="_img" :src="require(`@/images/${image}`)" alt=""></div>
                    </div>
                </div>
                


            </section>

            <section class="col box-3">
                <h4 class="title3" style="margin-bottom: 50px;">合作伙伴</h4>
                <ul class="brand-list">
                    <li><img src="../images/logo/36中食.jpg" alt=""></li>
                    <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                    <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                    <li><img src="../images/logo/39零售.jpg" alt=""></li>
                    <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                    <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                    <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                    <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                    <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                    <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                </ul>
            </section>
        </div>
        <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 26px;">服务联系</h4>
        <div class="box-fwlx">
            <section class="col box-3 ">
                <div class="box-fwlx-con">
                    <div class="div1">
                        <p>企微客服</p>
                        <img src="../images/img-kf.png" alt="">
                        <p>首席客服热线</p>
                        <span>010-86460766-861</span>
                    </div>
                    
                        <ul class="ul1">
                            <form id="form-zx2" action="">
                                <li class="li1">
                                    <label for="">公司名称</label>
                                    <input name="compnay" type="text" maxlength="50">
                                </li>
                                <li class="li1">
                                    <label for="">所在行业</label>
                                    <input name="industry" type="text" maxlength="30">
                                </li>
                                <li class="li1">
                                    <label for="">您的姓名</label>
                                    <input name="username" type="text" maxlength="20">
                                </li>
                                <li class="li1">
                                    <label for="">手机号码</label>
                                    <input name="phone" type="text">
                                </li>
                                <li>
                                    <label for="">咨询需求</label>
                                    <textarea name="content" id="" maxlength="200"></textarea>
                                </li>
                                <li>
                                    <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                </li>
                            </form>
                        </ul>
                    
                </div>
            </section>
        </div>
         <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data() {
            return {
                list:[{
                    label: '内部协同',
                    title: '展装云+设计云',
                    con: ['·项⽬沟通与协作','·客户记录跟踪','·设计模型下载','·全国⼯⼚资料共享'],
                    img: 'img-3-5.png',
                    url: ''
                },{
                    label: '业务拓展',
                    title: '展装云',
                    con: ['·平台资源导⼊','·海量会刊共享','·平台项⽬分享'],
                    img: 'img-3-6.png',
                    url: ''
                },{
                    label: '展示推广',
                    title: '展装云+设计云店铺+平台会员',
                    con: ['·赋能开设专属线上商店展','·搭建案例展示推广','·会展通讯社广告/专访','·设计云顶部广告'],
                    img: 'img-3-7.png',
                    url: ''
                }],
                image:'img-3-5.png'
            }
        },
        mounted(){
            let that = this
            $('#list-btn>li').on('click',function(){
                $(this).addClass('active').siblings('li').removeClass('active')
                var _index = $(this).index()
                var item = that.list[_index]
                $('#_title').text(item.title)
                var html = ''
                for(var i=0,j=item.con.length; i<j; i++){
                    html += '<li>'+item.con[i]+'</li>'
                }
                $('#_list').html(html)
                that.image = item.img
            })    
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/solution-3.vue